import { render } from "./BenefitsView.vue?vue&type=template&id=a62dcfe4&ts=true"
import script from "./BenefitsView.vue?vue&type=script&lang=ts"
export * from "./BenefitsView.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__